const consoleHello = (message) => {
    console.log(message);
}

export default consoleHello;